// Bad words dictionary and validation utilities
const BAD_WORDS = [
    // Common profanity
    'fuck', 'shit', 'bitch', 'ass', 'asshole', 'bastard', 'damn', 'hell',
    'crap', 'piss', 'dick', 'cock', 'pussy', 'cunt', 'whore', 'slut', 'hoe',
    
    // Racial slurs (partial list - add more as needed)
    'nigger', 'nigga', 'spic', 'chink', 'gook', 'kike', 'wetback',
    
    // Offensive terms
    'retard', 'fag', 'faggot', 'dyke', 'tranny',

    //Terrorism
    '911', 'Nine Eleven', 'Terrorist', 'Killer', 'Terrorism',

    //Sex
    'blowjob', 'anal', 'rimming', 'threesome', 'vagina', 'penis', 'creampie', 'cum',
    'cumming', 'orgasm', 'fingering', 'squirting', 'shitting',
    
    // Add more as needed
    'gooner', 'crackhead', 'semen', 'fart', 'farting', 'poop', 'pooper', 'pooping'
];

/**
 * Check if a name contains bad words
 * @param {string} name - The name to check
 * @returns {boolean} - True if name contains bad words, false otherwise
 */
export const containsBadWords = (name) => {
    if (!name || typeof name !== 'string') return false;
    
    const lowerName = name.toLowerCase();
    
    // Check for exact matches and partial matches
    return BAD_WORDS.some(badWord => {
        const regex = new RegExp(`\\b${badWord}\\b|${badWord}`, 'i');
        return regex.test(lowerName);
    });
};

/**
 * Sanitize a name by replacing bad words with asterisks
 * @param {string} name - The name to sanitize
 * @returns {string} - Sanitized name
 */
export const sanitizeName = (name) => {
    if (!name || typeof name !== 'string') return 'Anonymous';
    
    let sanitized = name;
    BAD_WORDS.forEach(badWord => {
        const regex = new RegExp(badWord, 'gi');
        sanitized = sanitized.replace(regex, '*'.repeat(badWord.length));
    });
    
    return sanitized;
};

/**
 * Check if user should be blocked from leaderboard
 * @param {string} name - The user's display name
 * @returns {boolean} - True if user should be blocked
 */
export const shouldBlockFromLeaderboard = (name) => {
    return containsBadWords(name);
};

/**
 * Get a safe display name for leaderboard
 * If name contains bad words, return "Anonymous"
 * @param {string} name - The original name
 * @returns {string} - Safe display name
 */
export const getSafeLeaderboardName = (name) => {
    if (containsBadWords(name)) {
        return 'Anonymous';
    }
    return name;
};

/**
 * Log users with inappropriate names (for admin review)
 * @param {string} userId - The user ID
 * @param {string} name - The inappropriate name
 * @param {string} email - The user's email
 */
export const logInappropriateName = (userId, name, email) => {
    console.warn('Inappropriate name detected:', {
        userId,
        name,
        email,
        timestamp: new Date().toISOString()
    });
    
    // You could also send this to a logging service or admin dashboard
    // For now, just console warning
};
